$(function() {
    // Ajax params
    let myajax = `//${window.location.host}/wp-admin/admin-ajax.php`,
        paramObj = {
            action: 'load_post',
            postType: null,
            url: myajax,
            catId: 'all',
            paged: 1,
        };

    // Ajax helper function
    function loadPosts(paramObj) {
        $.ajax({
            url: paramObj.url,
            data: paramObj,
            type: 'POST',

            beforeSend() {
                $('.js-ajax-load').css({
                    'opacity': '.3',
                    'pointer-events': 'none'
                });
            },

            success(data) {
                $('.js-ajax-load').html(data);
            },

            complete() {
                $('.js-ajax-load').css({
                    'opacity': '1',
                    'pointer-events': 'auto'
                });
            }
        });
    }

    // Get city from URL
    function getCityFromUrl() {
        const params = new URLSearchParams(window.location.search);

        return params.get('city') || '';
    }

    // Update URL
    function updateUrl(citySlug) {
        const url = new URL(window.location.href);

        if (citySlug) {
            url.searchParams.set('city', citySlug);
        } else {
            url.searchParams.delete('city');
        }

        // Reset pagination when changing filter
        url.searchParams.delete('paged');

        window.history.pushState({}, '', url);
    }

    // Load filter from URL
    function loadFilterFromUrl() {
        const citySlug = getCityFromUrl();

        let $filter;

        if (citySlug) {
            $filter = $('.js-load-post').filter(function() {
                return $(this).data('cat-slug') === citySlug;
            });
        } else {
            $filter = $('.js-load-post[data-cat-id="all"]');
        }

        if (!$filter.length) {
            return;
        }

        $('.js-load-post').removeClass('active');
        $filter.addClass('active');

        paramObj.catId = $filter.data('cat-id') || 'all';
        paramObj.postType = $filter.data('post-type');
        paramObj.paged = 1;

        loadPosts(paramObj);
    }

    // Filter
    $('body').on('click', '.js-load-post', function(e) {
        e.preventDefault();

        const $this = $(this),
            postType = $this.data('post-type'),
            catID = $this.data('cat-id'),
            citySlug = $this.data('cat-slug');

        if ($this.hasClass('active')) {
            return;
        }

        $('.js-load-post').removeClass('active');
        $this.addClass('active');

        paramObj.catId = catID ? catID : 'all';
        paramObj.postType = postType;
        paramObj.paged = 1;

        // Update URL
        updateUrl(citySlug);

        // Load posts
        loadPosts(paramObj);
    });

    // Pagination
    $(document).on('click', '.pi-pagination .page-numbers', function(e) {
        e.preventDefault();

        let catID = $(this).closest('.pi-pagination').data('cat');

        if (catID) {
            paramObj.catId = catID;
        }

        if ($(this).hasClass('next')) {
            paramObj.paged = Number(
                $('.pi-pagination .page-numbers.current').html()
            ) + 1;

        } else if ($(this).hasClass('prev')) {
            paramObj.paged = Number(
                $('.pi-pagination .page-numbers.current').html()
            ) - 1;

        } else {
            paramObj.paged = $(this).html();
        }

        loadPosts(paramObj);
    });

    // Initial load from URL
    loadFilterFromUrl();
});